import { Typography } from '@mui/material';
import { WithTranslation, withTranslation } from 'react-i18next';

import { useStyles } from './styles';

const Tag = ({ t: translate }: WithTranslation) => {
  const classes = useStyles();

  return (
    <Typography sx={classes.tag}>{translate('assistant.assistant')}</Typography>
  );
};

export default withTranslation('common')(Tag);
